import type {Editor} from 'grapesjs';
import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import {EmailMakerBlockManager} from '@Components/email-maker-block-manager/email-maker-block-manager';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';

/** Mounts the block manager into a detached modal container with its own React root + store. */
export function renderEmailMakerBlockManager(container: HTMLElement, editor: Editor): void {
  renderElement(
    container,
    <Provider store={window.PMW.redux.store}>
      <EmailMakerBlockManager gjsEditor={editor} mobileBreakpoint={ScreenBreakpoints.LARGE} />
    </Provider>
  );
}
